import React, { useState, useEffect } from 'react';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import clone from 'lodash/clone';
import keys from 'lodash/keys';

import each from 'lodash/each';

export default function WebSiteMap(props) {
	// Declare a new state variable, which we'll call "count"

	

	let getDataSet = (dataMap, filterV = false) => {
		if(filterV){ 
			dataMap = reduce(dataMap, (memo, value, key) => {
				let items = filter(value, (i, k) => {
					return (
						i.title.toLowerCase().indexOf(filterV.toLowerCase()) != -1 ||
						i.website.toLowerCase().indexOf(filterV.toLowerCase()) != -1 ||
						key.toLowerCase().indexOf(filterV.toLowerCase()) != -1
						)
				});
				memo[key] = items;
				return memo;
			}, {});
		}
		if(props.parent) {
			dataMap = dataMap[props.parent];
			if(props.groupByCategory){
				dataMap =groupBy(dataMap, 'category');
			}
		}
		return dataMap;
	}
	let dataMap = getDataSet(window.websiteMap);
	
	
	const [noresults, setNoresults] = useState(false);
	const [data, setData] = useState(dataMap);
	const [search, setSearch] = useState('');
	const [profileState, setProfileState] = useState(props);
   	
	let output = null;

	const list = (listData) => {
		const itemRows = [];
		let i = 0;
		for (let item of listData) {
			const row = (
				<li key={i}><a href={item.website}>{item.title}</a></li>
			);
			i++;
			itemRows.push(row);
		}  

		output = <ul>{itemRows}</ul>;
		return output;
	};

	const group = (data) => {
		if(data.length) {
			return list(data);
		} else {
			let group = null;
			group = Object.keys(data).map(function(keyName, keyIndex) {
				if(data[keyName].length) {
					output = <ul>{list(data[keyName])}</ul>;
						return (<div key={keyIndex}><h3>{keyName}</h3>
					  			<ul>{output}</ul></div>);
				} else {
					return null;
				}
			  	
			});
			output = (<div>{group}</div>);
			return output;
		}

	};

	function hasData() {
		if(data.length) {
			return data.true;
		} else {
			let ret = false;
			each(keys(data), (item, index) => {
				if(data[item].length) {
					ret = true;
				}
			});
			return !ret;
		}
	}

	 // Similar to componentDidMount and componentDidUpdate:
	useEffect(() => {
		// Update the document title using the browser API
	//	document.title = `You clicked ${count} times`;

		setNoresults(hasData());

	}, [data]);
	
	function updateView(evt) {
		setSearch(evt.target.value);
		if(evt.target.value != '') {
			let data = getDataSet(clone(window.websiteMap), evt.target.value);
			//getDataSet(dataMap,);
			setData(clone(data));
		} else {
			let data = getDataSet(window.websiteMap);
			setData(data);
		}
		
	}

	let noresultsMessage = null;
	if(noresults) {
		noresultsMessage = (<div>There are no restuls with the search '{search}'</div>)
	}
  	return (
	    <div>
	    	{JSON.stringify(noresults)}
	      	<input value={search} onChange={updateView} placeholder="search"/>
	      	{group(data)}
	      	{noresultsMessage}
	    </div>
	);
}


// WEBPACK FOOTER //
// ./src/WebSiteMap/index.js